import { ReactComponent as NoPrinter } from '../../assets/Printer_not_found.svg';
import Typography from '../Typography';
type Props = {
  height?: number;
  message?: string;
};

const NoPrinterFound = ({ message = ' ', height = 600 }: Props) => {
  return (
    <div>
      <NoPrinter height={height} />
      <div
        style={{
          textAlign: 'center',
        }}
      >
        <Typography variant="title" fontColor="secondary">
          {message}
        </Typography>
      </div>
    </div>
  );
};

export default NoPrinterFound;
